import { toast } from "sonner";
import { MapPin, Shirt, Camera, Users } from "lucide-react";
import { Reveal, MaskedLine } from "./Reveal";
import { useCoinCelebration, CASHAPP_URL } from "./coinCelebration";

const NEEDS = [
  { Icon: MapPin, text: "Locations that set the tone" },
  { Icon: Shirt, text: "Period costumes & practical props" },
  { Icon: Camera, text: "Professional cinema camera & lighting gear" },
  { Icon: Users, text: "Hiring our cast and crew" },
];

const DonationAppeal = () => {
  const { celebrate, layer } = useCoinCelebration();

  const donate = () => {
    celebrate(true);
    toast.success("Thank you for keeping the film rolling — every coin hits the screen.");
  };

  return (
    <Reveal delay={0.15}>
      <div data-testid="donation-appeal" className="mt-16 lg:mt-24 max-w-3xl mx-auto text-center">
        <h3 className="font-serif font-light text-cream text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight">
          <MaskedLine delay={0.05}>We need your help</MaskedLine>
          <MaskedLine delay={0.15}>
            to keep <em className="italic text-gold">FILMing</em> this.
          </MaskedLine>
        </h3>
        <p className="text-sm lg:text-base text-cream/60 leading-relaxed mt-7 max-w-2xl mx-auto">
          Great independent cinema takes real resources. To bring this vision to the screen
          the way it deserves to be told, we need to raise funds for:
        </p>

        <div className="grid sm:grid-cols-2 gap-4 mt-9 text-left max-w-2xl mx-auto">
          {NEEDS.map(({ Icon, text }, i) => (
            <div
              key={i}
              data-testid={`appeal-need-${i + 1}`}
              className="flex items-center gap-4 bg-tile border border-cream/10 hover:border-gold/50 transition-colors duration-300 px-5 py-4 clip-frame"
            >
              <span className="w-9 h-9 shrink-0 rounded-full bg-amber/15 border border-amber/40 flex items-center justify-center">
                <Icon size={15} className="text-gold" />
              </span>
              <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-cream/70 leading-relaxed">
                {text}
              </p>
            </div>
          ))}
        </div>

        <p className="text-sm lg:text-base text-cream/60 leading-relaxed mt-9 max-w-2xl mx-auto">
          We want you involved as a community to keep bringing real art to life. Every
          donation goes straight onto the screen.
        </p>
        <p className="font-serif italic font-light text-2xl text-gold mt-5">
          Help us build this world from the ground up.
        </p>

        <div className="relative inline-block mt-9">
          {layer}
          <a
            data-testid="appeal-donate-button"
            href={CASHAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={donate}
            className="inline-block bg-amber text-cream font-mono text-xs uppercase tracking-[0.3em] px-12 py-5 rounded-full hover:bg-gold hover:text-ink transition-colors duration-300 cursor-pointer"
          >
            Donate Now
          </a>
        </div>
      </div>
    </Reveal>
  );
};

export default DonationAppeal;
